import { Fragment } from "react";
import { Form } from "../../../components/form";
import { useSelector } from "react-redux";
import { UserInfoPageForm } from "./userinfoform";

import i18next from "i18next";
import { useTranslation } from "react-i18next";

export const UserInfo = (props) => {
  const {
    updateDirtyState,
    handleOnChangeField,
    onUpdateUserInfo,
    onChangePasswordClick,
  } = props;
  const currentTheme = useSelector((state) => state.currentTheme);
  const currentUser = useSelector((state) => state.currentUser);
  const pageState = useSelector((state) => state.accountManagementPage);

  const { t } = useTranslation();

  const toolbarRenderer = (props, t) => {
    return <Fragment></Fragment>;
  };
  return (
    <div>
      <h4>{t("accountmang.tabs.info")}</h4>
      <Form
        className="accountmanagement-page-form"
        currentTheme={currentTheme}
        currentUser={currentUser}
        toolbarRenderer={toolbarRenderer}
        t={t}
        errorMessages={pageState.formServerErrors} 
        pageState={pageState}
      >
        <UserInfoPageForm
          updateDirtyState={updateDirtyState}
          handleOnChangeField={handleOnChangeField}
          onUpdateUserInfo={onUpdateUserInfo}
          onChangePasswordClick={onChangePasswordClick}
        />
      </Form>
    </div>
  );
};
